
export class Cidade {
    codIbge: string;
    id: number;
    nome: string;
}